import Api from './Api';

const END_POINT = 'specialty'

export default {
    async get_all(filters = null) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request)
    },
    async store(zona) {
        return await Api.post(`${END_POINT}`, zona)
    },
    async update(zona) {
        return await Api.patch(`${END_POINT}/${zona.id}`, zona)
    },
    async change_status(zona) {
        return await Api.patch(`${END_POINT}/${zona.id}/change-status`, zona)
    },
    async delete(zona) {
        return await Api.delete(`${END_POINT}/${zona.id}`, zona)
    }
}